@if (addHelperTextForm) {
    <div class="add-helper-text-container" >
        <div class="hub-modal-header-text">
            <h5>Add New Helper Text</h5>
        </div>

        <mat-dialog-content class="hub-custom-scrollbar" [formGroup]="addHelperTextForm">
            <div class="add-helper-text-body">

                <div class="context-panel">
                    <div class="text-info-800">Context</div>
                    <input maxlength="255" type="text" class="form-control" formControlName="context" placeholder="Context">
                    <div class="hub-validation-error-message">
                        {{getValidationErrorMessages("context")}}
                    </div>
                </div>

                <div class="label-panel">
                    <div class="text-info-800">Label</div>
                    <input maxlength="255" type="text" class="form-control" formControlName="label" placeholder="Label">
                    <div class="hub-validation-error-message">
                        {{getValidationErrorMessages("label")}}
                    </div>
                </div>

                <div class="content-html-panel">
                    <div class="text-info-800">Content (HTML)</div>
                    <textarea maxlength="1000" formControlName="contentHtmlShort" placeholder="Content (HTML)"></textarea>

                    <div class="validation-messages">
                        <div class="hub-validation-error-message">
                            {{getValidationErrorMessages("contentHtmlShort")}}
                        </div>

                        <div class="chars-remaining" [ngClass]="{'out-of-space':(1000 - addHelperTextForm.controls.contentHtmlShort.value.length) <= 0}">
                            {{1000 - addHelperTextForm.controls.contentHtmlShort.value.length}}
                            character{{1000 - addHelperTextForm.controls.contentHtmlShort.value.length !== 1 ? 's' : ''}} remaining
                        </div>

                    </div>

                </div>

                <div class="link-panel">
                    <div class="text-info-800">Read More URL</div>
                    <input maxlength="2048" type="text" class="form-control" formControlName="link" placeholder="Read More Link">
                    <div class="hub-validation-error-message">
                        {{getValidationErrorMessages("link")}}
                    </div>
                </div>


            </div>
        </mat-dialog-content>

        <mat-dialog-actions>
            <button (click)="cancel()" class="cancel-button">Cancel</button>
            <button type="button" class="hub-icon-button SaveButton" [ngClass]="{'saving': isSaving}"
                [disabled]="addHelperTextForm.invalid || isSaving" (click)="save()">
                <b>
                <i class="icon-floppy-disk"></i>
                <i class="icon-spinner4"></i>
                </b>
                {{existingCollection ? 'Save' : 'Add'}}
            </button>
        </mat-dialog-actions>


    </div>
}
